/** Indian financial year: April (month 4) to March */

export const getFinancialYearStart = (date = new Date()) => {
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return month >= 4 ? year : year - 1;
};

export const formatFinancialYear = (startYear) => `${startYear}-${Number(startYear) + 1}`;

export const buildFinancialYearOptions = (count = 11) => {
    const start = getFinancialYearStart();
    return Array.from({ length: count }, (_, i) => start + i);
};

/** Local calendar YYYY-MM-DD (avoids UTC previous-day shift) */
export const getTodayDate = () => {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, "0");
    const d = String(now.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
};

/**
 * Normalize API/local dates to YYYY-MM-DD for <input type="date">.
 * Plain dates stay as-is; ISO datetimes use the local calendar day
 * so UTC midnight / IST offsets do not show as the previous day.
 */
export const toDateInputValue = (value) => {
    if (!value) return "";
    if (value instanceof Date && !Number.isNaN(value.getTime())) {
        const y = value.getFullYear();
        const m = String(value.getMonth() + 1).padStart(2, "0");
        const d = String(value.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    }

    const raw = String(value).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;

    const date = new Date(raw);
    if (!Number.isNaN(date.getTime())) {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    }

    const match = raw.match(/^(\d{4}-\d{2}-\d{2})/);
    return match ? match[1] : "";
};

export const formatDisplayDate = (value, emptyLabel = "—") => {
    const ymd = toDateInputValue(value);
    if (!ymd) return emptyLabel;
    const date = new Date(`${ymd}T00:00:00`);
    if (Number.isNaN(date.getTime())) return ymd;
    return date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const FY_MONTHS = [
    { value: 4, label: "April", short: "Apr" },
    { value: 5, label: "May", short: "May" },
    { value: 6, label: "June", short: "Jun" },
    { value: 7, label: "July", short: "Jul" },
    { value: 8, label: "August", short: "Aug" },
    { value: 9, label: "September", short: "Sep" },
    { value: 10, label: "October", short: "Oct" },
    { value: 11, label: "November", short: "Nov" },
    { value: 12, label: "December", short: "Dec" },
    { value: 1, label: "January", short: "Jan" },
    { value: 2, label: "February", short: "Feb" },
    { value: 3, label: "March", short: "Mar" },
];

export const CALENDAR_MONTH_NAMES = {
    1: "January", 2: "February", 3: "March", 4: "April",
    5: "May", 6: "June", 7: "July", 8: "August",
    9: "September", 10: "October", 11: "November", 12: "December",
};
